import axios from "axios"

//export const BACKEND_URL = "https://51.44.209.66:5000/";
export const BACKEND_URL = "https://api.spen-gespat.falendi.com/";

axios.defaults.baseURL = BACKEND_URL;

axios.interceptors.request.use(
  async (req) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      req.headers.accesstoken = token;
      req.headers.Authorization = `Bearer ${token}`;
    }
    if (req?.data instanceof FormData) {
      req.headers = {
        'Content-Type': 'multipart/form-data',
        ...req?.headers
      }
    }
    return req;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  response => response,
  async (error) => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 422) {
        window.location.href = "/login"
      }
    }
    return Promise.reject(error);
  }
);
